export default import.meta.ROLLDOWN_FILE_URL_yvB$7HDt$fxaXJ7DG0VO2g